import { Component, OnInit } from '@angular/core';
import { AllPageService } from "src/app/shared/services/all-page.service";
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as moment from "moment";
declare var jQuery: any;
declare var $: any;

@Component({
  selector: 'app-news-single',
  templateUrl: './news-single.component.html',
  styleUrls: ['./news-single.component.scss']
})
export class NewsSingleComponent implements OnInit {

  newssingleRequest: any = {};
	newsSingle: any = {};
  newsList: any = "";
  newsrequest: any = {};
  safeDescription: SafeHtml | null = null; 
  constructor(
    private allpagesService: AllPageService,
	  private activatedRoute:ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer // Inject DomSanitizer
  ) { }
  slidenewsConfig = {
    //dots: true,
    infinite: true,
    arrows: true,
    slidesToShow: 3,
    autoplay: false,
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  ngOnInit() {
    this.activatedRoute.params.subscribe((data)=>{
      if(data.slug){
        this.getNewslist(data.slug);
        //this.newsRequest = data.slug;
      }
      if(data.htmlslug){
        //this.getNewslist(data.slug);
        //this.newsRequest = data.slug;
        this.getNewslist(data.htmlslug.replace(".html",""));
      }
      });
    
  }

  getNewslist(newsslug) {
    this.newssingleRequest.slug = newsslug;
    let request = Object.assign({}, this.newssingleRequest)
    this.allpagesService.getNewsDetails(request).then((data) => {
        if(data.status == 1)
        {
       this.newsSingle = data.data || {};
       this.safeDescription = this.sanitizer.bypassSecurityTrustHtml(
        this.newsSingle.description
      ); // Sanitize the HTML
       this.newsrequest = {
        news_catagory_id: data.data.news_catagory_id
      }
      this.loadnews();
      
       
       console.log(this.newsSingle);
    }else{
      this.router.navigate(['/news']);
    }
    });
  }

  loadnews(concat:boolean = false) {
    let request = Object.assign({}, this.newsrequest);
    this.allpagesService.getNewsListing(request).then((data: any) => {
      
      if(data.data.length > 0)
         {
           if (concat) {
            this.newsList = this.newsList.concat(data.data);
        console.warn(this.newsList);
           
          } else {
            this.newsList = data.data;
        console.log(this.newsList);
           
          }   
         }
         else{
      this.newsList = "";
          
         }
      
    });
  }

}
